module.exports = __webpack_public_path__ + "img/11.8ce6880f.jpg";